<template>
  <b-card v-if="render">
    <b-form class="position-relative feedback">
      <LayoutLoading v-if="itemLoading" />
      <b-row>
        <!--  -->
        <b-col md="6">
          <label
            for=""
            class="feedback-label"
          >{{ $t('general.fullName') }}: <span>{{ form.name }}</span></label>
        </b-col>
        <!--  -->
        <b-col md="6">
          <label
            for=""
            class="feedback-label"
          >{{ $t('general.email') }}: <span>{{ form.email }}</span></label>
        </b-col>
        <!--  -->
        <b-col md="6">
          <label
            for=""
            class="feedback-label"
          >{{ $t('general.phone') }}: <span>{{ form.phone }}</span></label>
        </b-col>
        <!--  -->
        <b-col md="6">
          <label
            for=""
            class="feedback-label"
          >{{ $t('unit.unit') }}: <span>{{ form.unit ? form.unit.title : '' }}</span></label>
        </b-col>
        <!--  -->
        <b-col
          md="12"
          class="feedback-message"
        >
          <label
            for=""
            class="feedback-label"
          >{{ $t('suggestions.message') }}: </label>
          <p class="desc">
            {{ form.content }}
          </p>
        </b-col>
        <!--  -->
        <b-col
          cols="3"
          class="d-flex align-items-center"
        >
          <b-col
            md="4"
            cols="6"
          >
            <b-form-group
              :label="$t('suggestions.archive')"
              label-for="suggestion-archive"
              class="mt-1"
            >
              <b-form-checkbox
                id="suggestion-archive"
                v-model="form.archive"
                name="suggestion-archive"
                class="mt-1"
                switch
                inline
                @change="(val) => toggleArchive(item._id, val)"
              />
            </b-form-group>
          </b-col>
          <b-col
            cols="6"
            class="mt-2"
          >
            <b-button
              v-ripple.400="'rgba(186, 191, 199, 0.15)'"
              variant="outline-secondary"
              @click="$router.go(-1)"
            >
              {{ $t("general.back") }}
            </b-button>
          </b-col>
        </b-col>

      </b-row>
    </b-form>
  </b-card>
</template>

<script>
import {
  BButton, BCard, BCol, BForm, BFormCheckbox, BFormGroup, BRow,
} from 'bootstrap-vue'
import '@/components/BFormInvalid/index.vue'
import LayoutLoading from '@/components/LayoutLoading.vue'
import Ripple from 'vue-ripple-directive'
import { required, email, minLength } from 'vuelidate/lib/validators'
import useFeedbackList from './useFeedbackList'

export default {
  name: 'FeedbackEdit',
  components: {
    BButton,
    BCard,
    BCol,
    BForm,
    BFormCheckbox,
    BFormGroup,
    BRow,
    LayoutLoading,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      unit: {},
    }
  },
  computed: {
    itemId() {
      return this.$router.currentRoute.params.id
    },
    render() {
      return this.item ? this.item && Object.keys(this.item).length : true
    },
  },
  created() {
    this.fetchItem(this.itemId, this.form.unit)
  },
  validations: {
    form: {
      name: {
        required,
        minLength: minLength(3),
      },
      email: {
        email,
      },
      phone: {
        required,
      },
      content: {
        required,
      },
      archive: {},
      unit: {},
    },
  },
  methods: {
    validateState(name) {
      const {
        $dirty,
        $error,
      } = this.$v.form[name]
      return $dirty ? !$error : null
    },
    submitForm() {
      this.$v.$touch()
      if (!this.$v.$invalid) {
        this.sendData()
      }
    },
    sendData() {
      const data = {
        name: this.form.name,
        email: this.form.email,
        phone: this.form.phone,
        content: this.form.content,
        archive: this.form.archive,
        unit: this.form.unit,
      }
      this.updateItem(this.itemId, data, this.form.lang)
    },
  },
  setup() {
    const {
      fetchItem,
      form,
      isSubmit,
      item,
      itemLoading,
      updateItem,
      toggleArchive,
    } = useFeedbackList()
    return {
      fetchItem,
      form,
      isSubmit,
      item,
      itemLoading,
      updateItem,
      toggleArchive,
    }
  },
}
</script>
